import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { QUERY_KEYS } from 'constants/common';
import { SURVEY_TYPES } from 'constants/surveys';
import { SurveyService } from 'services/surveys';
import type { SurveyType, Survey } from 'types/surveys';

export const useGetSurveys = (surveyType: SurveyType): UseQueryResult<Survey[]> => {
  const isDailyTracking = surveyType === SURVEY_TYPES.DAILY;
  const today = isDailyTracking ? format(new Date(), 'yyyy-MM-dd') : undefined;

  return useQuery<AxiosResponse<Survey[]>, Error, Survey[]>({
    queryKey: today
      ? [QUERY_KEYS.FETCH_SURVEYS, surveyType, today]
      : [QUERY_KEYS.FETCH_SURVEYS, surveyType],
    queryFn: () => SurveyService.getUserSurveys(surveyType),
    select: response => response.data,
  });
};
